import { Measure } from 'services/model/model.service';
import { ChartConfig } from './ChartConfig';
import { ChartDataArray } from './ChartDataArray';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { InterpretationValue } from 'models/measureInterpretation';

export class LineChartConfig extends ChartConfig {
  showChange?: boolean;

  removeOuterSpacing?: boolean;

  // hint: This would be better as a part of ChartDataArray (as child array)
  breakdownData?: ChartDataArray[];

  rotateXLabels?: boolean;

  tickPadding = 20;

  breakdownMode?: string;

  additionalAxis?: boolean;

  showTooltips = true;

  static forTBMeasure(measure: Measure, isBreakdownMode?: boolean): LineChartConfig {
    const lineChartConfig = new LineChartConfig();
    lineChartConfig.value = {
      code: measure.code,
      label: measure.metric.name,
      unit: measure.metric.unit,
      interpretation: measure.metric.interpretation,
    };
    lineChartConfig.legendConfig = {
      hide: false,
    };
    lineChartConfig.breakdownMode = isBreakdownMode ? 'parallel' : undefined;
    return lineChartConfig;
  }

  static forCustomMeasure(
    measureCode: string,
    label: string,
    unit: MeasureUnitCode,
    interpretation: InterpretationValue,
    isBreakdownMode?: boolean
  ): LineChartConfig {
    const lineChartConfig = new LineChartConfig();
    lineChartConfig.value = {
      code: measureCode,
      label: label,
      unit: unit,
      interpretation: interpretation,
    };
    lineChartConfig.legendConfig = {
      hide: false,
    };
    lineChartConfig.breakdownMode = isBreakdownMode ? 'parallel' : undefined;
    return lineChartConfig;
  }
}
